export default {
  name: "dr-secondary-button",
  props: {
    icon: {
      type: String,
      required: true
    },
    toggled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    inputListeners: function() {
      var vm = this;

      return Object.assign({}, this.$listeners, {
        input: function(event) {
          vm.$emit("input", event.target.value);
        }
      });
    }
  }
};
